function FormFieldGroup({ children }) {
  return (
    <div className="ui-form-field-group">
      {children}
    </div>
  );
}

export default FormFieldGroup;